/* global axios */
import ApiClient from '../ApiClient';

// MCP-серверы — внешние источники инструментов агентов (Р9.4).
class AssistantMcpServers extends ApiClient {
  constructor() {
    super('assistant/mcp_servers', { accountScoped: true });
  }

  create(data = {}) {
    return axios.post(this.url, { mcp_server: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { mcp_server: data });
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }
}

export default new AssistantMcpServers();
